import React, { useContext, useEffect, useState } from "react";

import globalStyles from "../../Styles/global.module.scss";
import dashboardStyles from "../../Styles/ComponentStyles/MainPages/dashboard.module.scss";
import appClientStyles from "../../Styles/ComponentStyles/GlobalComponentStyles/AppClientMarketingDialog.module.scss"
import portfolioStyles from "../../Styles/ComponentStyles/GlobalComponentStyles/PortfolioDialog.module.scss";
import resourceStyles from "../../Styles/ComponentStyles/GlobalComponentStyles/NewResourceDialog.module.scss";

import {
    IconButton,
    Typography,
    Divider,
    FormControlLabel,
    RadioGroup,
    Radio,
} from "@mui/material";
import { Category, Close as CloseIcon } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import GlobalButton from "../../Utils/Layout/GlobalButton/GlobalButton";
import GlobalDropZone from "../../Utils/Layout/GlobalDropZone/GlobalDropZone";
import GlobalTextfield from "../../Utils/Layout/GlobalTextfield/GlobalTextfield";
import GlobalAutocomplate from "../../Utils/Layout/GlobalAutocomplate/GlobalAutoComplate";
import { DashboardContext, DashboardDetailPayload } from "../../Context/DashboardDetailContext";
import agent from "../../Services/api";
import GlobalSymbols from "../../Utils/Layout/GlobalSymbols/GlobalSymbols";
import { deleteResourceFileInterface, MarketAndSalesResourcePayloadDataModel, updateResourceInterface } from "../../models/dashboardAxiosModels";
import { GlobalUserContext, GlobalUserContextPayload } from "../../Context/GlobalUserDetailContext";
import { useSnackbar } from "../../Utils/Layout/GlobalSnackbar/GlobalSnackbar";

function MarketAndSalesResourceDialog(props: any) {

    const { setFlagNewResourceDialog, flag, onClose, marketAndSalesPdfId
    } = props

    const {
        setFlagLoader,
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const {
        uploadResourceFormData,
        setUploadResourceFormData,
        // uploadResourceFile,
        getMarketAndSalesDetails,
        marketingAndSalesResorcePayloadDetails,
        setMarketingAndSalesResorcePayloadDetails,
        marketAndSalesResourceDetails,
        setMarketAndSalesResourceDetails,
    } = useContext(DashboardContext) as DashboardDetailPayload

    const MAX_FILE_SIZE = 2 * 1024 * 1024;
    const { showSnackbar } = useSnackbar();
    const [error, setError] = useState<boolean>(false);
    const [selectedAttachFile, setSelectedAttachFile] = useState<any>(null);
    const [selectedPDFThumbnail, setSelectedPDFThumbnail] = useState<any>(null);
    const [uploadProgress, setUploadProgress] = useState<boolean>(false);
    const [renderSection, setRenderSection] = useState<string | File | null>("pdf");
    const [uploadProgressAttach, setUploadProgressAttach] = useState<any>(null);
    const [uploadProgressThumbnail, setUploadProgressThumbnail] = useState<any>(null);

    useEffect(() => {
        if (marketingAndSalesResorcePayloadDetails?.hyperlink) {
            setRenderSection("hyperlink")
        } else {
            setRenderSection("pdf")
        }
        if (marketingAndSalesResorcePayloadDetails?.google_storage_file_id) {
            setSelectedAttachFile(marketingAndSalesResorcePayloadDetails.file);
        }
        if (marketingAndSalesResorcePayloadDetails?.google_storage_thumbnail_id) {
            setSelectedPDFThumbnail(marketingAndSalesResorcePayloadDetails.thumbnail);
        }
    }, [marketAndSalesPdfId])

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value == "pdf") {
            setRenderSection("pdf")
            setMarketingAndSalesResorcePayloadDetails((prev: any) => ({
                ...prev,
                categoryName: "",
                hyperlink: null,
                hyperlink_name: null,
                description: ""
            }))
        } else {
            setRenderSection("hyperlink")
            setMarketingAndSalesResorcePayloadDetails((prev: any) => ({
                ...prev,
                categoryName: "",
                description: ""
            }))
            setSelectedAttachFile(null)
        }
    };

    const handleFileSelect = (file: File | null, type: 'attach' | 'thumbnail') => {
        if (file && file.size > MAX_FILE_SIZE) {
            if (type === 'attach') {
                setSelectedAttachFile(null);
            } else {
                setSelectedPDFThumbnail(null);
            }
        }
        if (file) {
            handleUploadFile(file, type);
            setError(false)
        } else {
            setError(true);
        }
    };

    const handleUploadFile = async (file: File, type: 'attach' | 'thumbnail') => {
        if (!file) return;

        if (type === 'attach') {
            setUploadProgressAttach(true);
        } else {
            setUploadProgressThumbnail(true);
        }

        const formData = new FormData();
        formData.append("file", file);
        const response = await agent.uploadResourceFileAPI.post(formData)

        if (response?.status) {
            console.log("Upload successful:", response);
            const responseData = response?.data
            if (type === 'attach') {
                setSelectedAttachFile(responseData);
                setUploadProgressAttach(false);
            } else {
                setSelectedPDFThumbnail(responseData);
                setUploadProgressThumbnail(false)
            }
        }
        else {
            console.error("Upload failed:", response);
            if (type === 'attach') {
                setSelectedAttachFile(null);
                setUploadProgressAttach(null); // Reset progress
            } else {
                setSelectedPDFThumbnail(null);
                setUploadProgressThumbnail(null); // Reset progress
            }
        }
    };

    const handleFileCancel = async (type: 'attach' | 'thumbnail') => {

        if (type === 'attach') {
            setSelectedAttachFile(null);
            setUploadProgressAttach(false);
        } else if (type === 'thumbnail') {
            setSelectedPDFThumbnail(null);
            setUploadProgressThumbnail(false);
        }

        // setFlagLoader(true)

        // let deleteResourceFileId;
        // if (type === 'attach') {
        //     deleteResourceFileId = selectedAttachFile?.google_storage_id
        // } else {
        //     deleteResourceFileId = selectedPDFThumbnail?.google_storage_id
        // }
        // // console.log(deleteResourceFileId)

        // // const payload: deleteResourceFileInterface = {
        // //     id: deleteResourceFileId
        // // }
        // const response = await agent.deleteResourceFileAPI.delete(deleteResourceFileId)
        // console.log("response", response)

        // if (response?.status) {
        //     console.log("Delete successful", response?.message);
        //     showSnackbar(response?.message ? response?.message : "Delete successful", 'success')
        //     if (type === 'attach') {
        //         setFlagLoader(false)
        //         setSelectedAttachFile(null);
        //         setUploadProgressAttach(false);

        //     } else if (type === 'thumbnail') {
        //         setFlagLoader(false)
        //         setSelectedPDFThumbnail(null);
        //         setUploadProgressThumbnail(false);
        //     }
        // } else {
        //     console.log("Delete failed", response)
        //     showSnackbar(response?.error?.message ? response?.error?.message : 'Delete failed', 'error')
        //     setFlagLoader(false)
        // }
    };

    const handleAddMarketingResource = async () => {

        if (error) {
            showSnackbar("Please upload a Pdf", "error")
            return
        }
        if (renderSection === "hyperlink" && marketingAndSalesResorcePayloadDetails?.hyperlink) {
            const hyperlink = marketingAndSalesResorcePayloadDetails?.hyperlink;
            // Validate the hyperlink with regex
            const urlRegex = /^((https?|ftp):\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(:[0-9]{1,5})?(\/[^\s]*)?$/;
            if (!urlRegex.test(hyperlink)) {
                showSnackbar("Please enter valid Hyperlink.", "error");
                return;
            }
        }
        if ((flag == "Add New Resource" && !marketingAndSalesResorcePayloadDetails?.categoryName) && (!selectedAttachFile?.google_storage_id) && (!marketingAndSalesResorcePayloadDetails?.hyperlink_name && !marketingAndSalesResorcePayloadDetails?.hyperlink) && !marketingAndSalesResorcePayloadDetails?.description) {
            showSnackbar("Please fill all the fields.", "error");
            return
        }
        // validation for category name
        if (flag == "Add New Resource" && !marketingAndSalesResorcePayloadDetails?.categoryName) {
            showSnackbar("Please fill category name.", "error");
            return;
        }
        // validation for pdf
        if (renderSection === "pdf" && !selectedAttachFile?.google_storage_id) {
            showSnackbar("Please upload a PDF.", "error");
            return;
        }
        // validation for hyperlink
        if (renderSection === "hyperlink") {
            if (!marketingAndSalesResorcePayloadDetails?.hyperlink_name) {
                showSnackbar("Please fill hyperlink name.", "error");
                return;
            }
            if (!marketingAndSalesResorcePayloadDetails?.hyperlink) {
                showSnackbar("Please fill hyperlink.", "error");
                return;
            }
        }
        // validation for description
        if (!marketingAndSalesResorcePayloadDetails?.description) {
            showSnackbar("Please fill description.", "error");
            return;
        }
        setFlagLoader(true)

        let response;
        if (marketAndSalesPdfId) {
            // payload to update resource
            const payload: updateResourceInterface = {
                categoryName: marketingAndSalesResorcePayloadDetails?.categoryName ?? "",
                categoryID: marketingAndSalesResorcePayloadDetails?.categoryID ?? null,
                marketandsales_pdf_new_id: marketAndSalesPdfId,
                resource:
                {
                    google_storage_file_id: selectedAttachFile?.google_storage_id ?? null,
                    google_storage_thumbnail_id: selectedPDFThumbnail?.google_storage_id ?? null,
                    hyperlink: marketingAndSalesResorcePayloadDetails?.hyperlink ?? null,
                    hyperlink_name: marketingAndSalesResorcePayloadDetails?.hyperlink_name ?? null,
                    description: marketingAndSalesResorcePayloadDetails?.description ?? "",
                }
            }
            response = await agent.marketAndSalesResourceUpdateAPI.put(payload)

        } else {
            // payload to create new resource
            const payload: MarketAndSalesResourcePayloadDataModel = {
                categoryName: marketingAndSalesResorcePayloadDetails?.categoryName ?? "",
                categoryID: marketingAndSalesResorcePayloadDetails?.categoryID ?? null,
                description: marketingAndSalesResorcePayloadDetails?.description ?? "",
                hyperlink: marketingAndSalesResorcePayloadDetails?.hyperlink ?? null,
                hyperlink_name: marketingAndSalesResorcePayloadDetails?.hyperlink_name ?? null,
                google_storage_file_id: selectedAttachFile?.google_storage_id ?? null,
                google_storage_thumbnail_id: selectedPDFThumbnail?.google_storage_id ?? null
            };
            response = await agent.marketAndSalesResourceAPI.post(payload)
        }
        if (response?.status && response?.data) {
            const getMarketResponse = await getMarketAndSalesDetails();
            console.log("response of getMarketAndSalesDetails", getMarketResponse);

            if (marketAndSalesPdfId) {
                const successMessage = response?.data?.message ? response?.data?.message : "Resource updated successfully!"
                showSnackbar(successMessage, "success")
            } else {
                showSnackbar("Resource added successfully", "success")
            }
            if (getMarketResponse?.status) {
                if (getMarketResponse?.data && Array.isArray(getMarketResponse.data)) {
                    setMarketAndSalesResourceDetails(getMarketResponse.data);
                }
                setFlagLoader(false)
            }
            else {
                const error = getMarketResponse?.data?.error?.message || "Something Went Wrong!"
                setMarketAndSalesResourceDetails([]);
                showSnackbar(error, "error")
                setFlagLoader(false)
            }
        }
        else {
            const error = response?.data?.error?.message || "Something Went Wrong!"
            showSnackbar(error, "error")
            setFlagLoader(false)
        }
        setFlagNewResourceDialog(false)
        setMarketingAndSalesResorcePayloadDetails({
            categoryName: "",
            categoryID: null,
            description: "",
            hyperlink: null,
            hyperlink_name: null,
            google_storage_file_id: null,
            google_storage_thumbnail_id: null,
            file: null,
            thumbnail: null
        })
    }

    return (
        <>
            <Grid container sx={{ padding: '20px 0px' }}>
                <Grid size={{ xs: 12 }}>
                    <Grid container>
                        {flag === "Add New Resource" &&
                            <Grid size={{ xs: 12 }} className={`${resourceStyles.gblItemSpacing}`}>
                                <Grid container>
                                    <Grid size={{ xs: 12 }} sx={{ margin: "0px 0px 10px" }}>
                                        <Typography
                                            component={"span"}
                                            className={`${globalStyles.globalTextV17} ${globalStyles.gblCWhite}`}
                                        >
                                            Category Name <GlobalSymbols symbol="astric" />
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <GlobalTextfield
                                            placeholder="Enter Category Name"
                                            fullWidth
                                            size="medium"
                                            autoComplete="off"
                                            value={marketingAndSalesResorcePayloadDetails?.categoryName ?? ""}
                                            onChange={(e) =>
                                                setMarketingAndSalesResorcePayloadDetails((prev: any) => ({
                                                    ...prev,
                                                    categoryName: e.target.value,
                                                }))
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                        {(flag === "Add New Resource" || marketingAndSalesResorcePayloadDetails?.categoryID) &&
                            <Grid size={{ xs: 12 }} className={`${resourceStyles.gblItemSpacing}`}>
                                <Grid container>
                                    <Grid size={{ xs: 12 }}>
                                        <Typography
                                            component={"span"}
                                            className={`${globalStyles.globalTextV17} ${globalStyles.gblCWhite}`}
                                        >
                                            Upload Format
                                        </Typography>
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <RadioGroup row name="upload-format" value={renderSection} onChange={handleRadioChange}>
                                            <FormControlLabel
                                                value="pdf"
                                                control={<Radio sx={{ color: "white", "&.Mui-checked": { color: "white" } }} />}
                                                label="PDF"
                                                sx={{ color: "white" }}
                                            />
                                            <FormControlLabel
                                                value="hyperlink"
                                                control={<Radio sx={{ color: "white", "&.Mui-checked": { color: "white" } }} />}
                                                label="HyperLink"
                                                sx={{ color: "white" }}
                                            />
                                        </RadioGroup>
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                        {(renderSection == "pdf") &&
                            <>
                                <Grid size={{ xs: 12 }} className={`${resourceStyles.gblItemSpacing}`}>
                                    <Grid container className={`${resourceStyles.imageContainer}`}>
                                        <Grid size={{ xs: 12, sm: 5.8 }}>
                                            <Grid container sx={{ margin: "0px 0px 10px", alignItems: "center" }}>
                                                <Grid size={{ xs: 12 }} sx={{ marginBottom: "10px" }}>
                                                    <Typography
                                                        component={"span"}
                                                        className={`${globalStyles.globalTextV17} ${globalStyles.gblCWhite}`}
                                                    >
                                                        Attach File <GlobalSymbols symbol="astric" />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }} >
                                                    <GlobalDropZone
                                                        selectedFile={selectedAttachFile}
                                                        handleFileSelect={(file: File | null) => handleFileSelect(file, 'attach')}
                                                        disabled={uploadProgress}
                                                        uploadProgress={uploadProgressAttach}
                                                        allowedType="pdf"
                                                        handleCancel={() => handleFileCancel("attach")}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 5.8 }}>
                                            <Grid
                                                container
                                                sx={{ margin: "0px 0px 10px", alignItems: "center" }}
                                            >
                                                <Grid size={{ xs: 12 }} sx={{ marginBottom: "10px" }}>
                                                    <Typography
                                                        component={"span"}
                                                        className={`${globalStyles.globalTextV17} ${globalStyles.gblCWhite}`}
                                                    >
                                                        PDF Thumbnail
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalDropZone
                                                        selectedFile={selectedPDFThumbnail}
                                                        handleFileSelect={(file: File | null) => handleFileSelect(file, 'thumbnail')}
                                                        disabled={uploadProgress}
                                                        uploadProgress={uploadProgressThumbnail}
                                                        allowedType="image"
                                                        handleCancel={() => handleFileCancel("thumbnail")}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        }
                        {(renderSection == "hyperlink") &&
                            <>
                                <Grid size={{ xs: 12 }} className={`${resourceStyles.gblItemSpacing}`}>
                                    <Grid container>
                                        <Grid size={{ xs: 12 }} sx={{ marginBottom: "10px" }}>
                                            <Typography
                                                component={"span"}
                                                className={`${globalStyles.globalTextV17} ${globalStyles.gblCWhite}`}
                                            >
                                                Hyperlink Name <GlobalSymbols symbol="astric" />
                                            </Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12 }} sx={{ marginBottom: "10px" }}>
                                            <GlobalTextfield
                                                fullWidth
                                                size="medium"
                                                autoComplete="off"
                                                value={marketingAndSalesResorcePayloadDetails?.hyperlink_name ?? ""}
                                                onChange={(e) =>
                                                    setMarketingAndSalesResorcePayloadDetails((prev: any) => ({
                                                        ...prev,
                                                        hyperlink_name: e.target.value,
                                                    }))
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 12 }} className={`${resourceStyles.gblItemSpacing}`}>
                                    <Grid container>
                                        <Grid size={{ xs: 12 }} sx={{ marginBottom: "10px" }}>
                                            <Typography
                                                component={"span"}
                                                className={`${globalStyles.globalTextV17} ${globalStyles.gblCWhite}`}
                                            >
                                                Add Hyperlink <GlobalSymbols symbol="astric" />
                                            </Typography>
                                        </Grid>
                                        <Grid size={{ xs: 12 }} sx={{ marginBottom: "10px" }}>
                                            <GlobalTextfield
                                                fullWidth
                                                size="medium"
                                                autoComplete="off"
                                                value={marketingAndSalesResorcePayloadDetails?.hyperlink ?? ""}
                                                onChange={(e) =>
                                                    setMarketingAndSalesResorcePayloadDetails((prev: any) => ({
                                                        ...prev,
                                                        hyperlink: e.target.value,
                                                        google_storage_file_id: null
                                                    }))
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        }
                        <Grid size={{ xs: 12 }} className={`${resourceStyles.gblItemSpacing}`}>
                            <Grid container>
                                <Grid size={{ xs: 12 }} sx={{ margin: "0px 0px 10px" }}>
                                    <Typography
                                        component={"span"}
                                        className={`${globalStyles.globalTextV17} ${globalStyles.gblCWhite}`}
                                    >
                                        Description <GlobalSymbols symbol="astric" />
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <GlobalTextfield
                                        placeholder="Enter Description"
                                        fullWidth
                                        size="medium"
                                        autoComplete="off"
                                        multiline={true}
                                        maxRows={3}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                padding: '8.5px 4px',
                                            }
                                        }}
                                        value={marketingAndSalesResorcePayloadDetails?.description ?? ""}
                                        onChange={(e) =>
                                            setMarketingAndSalesResorcePayloadDetails((prev: any) => ({
                                                ...prev,
                                                description: e.target.value,
                                            }))
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ xs: 12 }} className={`${resourceStyles.gblItemSpacing}`}>
                            <Grid container className={`${portfolioStyles.btnContainers}`}>
                                <Grid>
                                    <GlobalButton
                                        value="Submit"
                                        size="large"
                                        className={`${dashboardStyles.raSubmitBtn}`}
                                        onClick={() => { handleAddMarketingResource() }}
                                    />
                                </Grid>
                                <Grid>
                                    <GlobalButton
                                        fullWidth
                                        value='Close'
                                        size='large'
                                        className={`${appClientStyles.closeBtnStyle}`}
                                        onClick={onClose}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </>
    )
}

export default MarketAndSalesResourceDialog